import React from 'react';
import { FacetProps } from '../Facets';
import {FilterItem} from '../FilterItem';
import { FacetItem } from '../../../../types/Search';

import './NumericRangeFacet.scss';

/**
 * Component which renders a numeric range selection facet.
 * Shows total number of documents as well as doc count per value
 * as returned by the search aggregation
 */
class NumericRangeFacet extends React.Component<FacetProps> {

  onSelect = (key: string) => {
    const {data, fieldType, field, facetType} = this.props.model;
    const selectedItem: FacetItem = data[key];
    if (selectedItem.selected) {
      this.props.onDeselect(key);
    } else {
      const numericRange = {
        key: selectedItem.key,
        min: selectedItem.rangeData.min,
        max: selectedItem.rangeData.max
      };
      this.props.onSelect({key, field, fieldType, facetType, value: numericRange});
    }
  };

  render() {
    const {data} = this.props.model;

    return (
      <div className="NumericRangeFacet">
        <div>
          {
            Object.keys(data).map((key: string) => {
                const item = data[key];
                const label = `${item.rangeData.min} - ${item.rangeData.max}`;
                return <FilterItem key={key}
                                   item={item}
                                   itemKey={key}
                                   onSelectEventHandler={() => this.onSelect(key)}
                                   customLabel={label}/>
              }
            )
          }
        </div>
      </div>
    )
  }
}

export default NumericRangeFacet;
